export const Version = () => {
    return (
        <p>Version 1.0.1</p>
    )
}